import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { db } from '../../lib/supabase'

export default function BrandsApi() {
  const navigate = useNavigate()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data: tiendas } = await db.getTiendas()
        
        const brands = tiendas?.filter(t => t.publicado).map(tienda => ({
          "@type": "Store",
          id: tienda.id,
          name: tienda.nombre,
          description: tienda.descripcion || `Tienda ${tienda.nombre} en Plaza Aurora Outlet`,
          category: tienda.categorias?.nombre || null,
          url: `https://www.plazaaurora.pe/marcas/${tienda.id}`,
          logo: tienda.logo_url || null,
          image: tienda.foto_url || null,
          localNumber: tienda.nro_local || null,
          telephone: tienda.telefono || null,
          openingHours: tienda.horario || "Lunes a Domingo: 10:00 AM - 10:00 PM",
          discounts: tienda.descuentos?.map(d => ({
            title: d.titulo,
            description: d.descripcion,
            validUntil: d.fecha_fin
          })) || [],
          rating: tienda.puntuacion_promedio || 0,
          seo: {
            title: tienda.seo_title || null,
            description: tienda.seo_description || null,
            ogImage: tienda.og_image_url || null
          }
        })) || []

        const response = {
          "@context": "https://schema.org",
          "@type": "ItemList",
          name: "Tiendas en Plaza Aurora Outlet",
          description: "Listado de todas las tiendas y marcas disponibles en Plaza Aurora, el mejor outlet de Lima Norte",
          numberOfItems: brands.length,
          itemListElement: brands.map((brand, index) => ({
            "@type": "ListItem",
            position: index + 1,
            item: brand
          }))
        }

        // Return as JSON
        const blob = new Blob([JSON.stringify(response, null, 2)], { type: 'application/json' })
        const url = URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.download = 'brands.json'
        link.click()
        URL.revokeObjectURL(url)
        
        // Redirect after download
        setTimeout(() => navigate('/marcas'), 1000)
      } catch (error) {
        console.error('Error generating brands.json:', error)
        navigate('/marcas')
      }
    }

    fetchData()
  }, [navigate])

  return (
    <div style={{ 
      maxWidth: '600px', 
      margin: '4rem auto', 
      padding: '2rem',
      textAlign: 'center'
    }}>
      <h1 style={{ fontFamily: 'var(--font-display)', marginBottom: '1rem' }}>
        Generando brands.json...
      </h1>
      <p style={{ color: 'var(--color-text-muted)' }}>
        Tu descarga comenzará en un momento.
      </p>
    </div>
  )
}
